// Add your custom JS here.
jQuery(function ($) {
    let isScrolled = false;

    $(window).on("scroll", function () {
        const scroll = $(window).scrollTop();
        const header = $("header.header-site");

        if (!isScrolled && scroll > 60) {
            isScrolled = true;
            header.addClass("scrolled");
        } else if (isScrolled && scroll < 20) {
            isScrolled = false;
            header.removeClass("scrolled");
        }
    });
});

jQuery(document).ready(function ($) {
    $('[tabindex="0"]').keydown(function (event) {
        if (event.key === "Enter" || event.key === " ") {
            $(this).click();
        }
    });
});

/*skip content*/
document.addEventListener("DOMContentLoaded", function () {
    const LinkGoSecondSection = document.getElementById("GoSecondSection");
    if (!LinkGoSecondSection) return;
    LinkGoSecondSection.addEventListener("click", function (event) {
        event.preventDefault();
        const secondSection = document.querySelector(
            ".general-section:nth-of-type(2)",
        );
        if (secondSection) {
            secondSection.scrollIntoView({ behavior: "smooth" });
        } else {
            console.error("the second section was not found.");
        }
    });
});

function autosize() {
    var el = this;
    setTimeout(function () {
        el.style.cssText = "height:auto; padding:0";
        // for box-sizing other than "content-box" use:
        // el.style.cssText = '-moz-box-sizing:content-box';
        el.style.cssText = "height:" + (el.scrollHeight + 2) + "px";
    }, 0);
}

document.fonts.ready.then(function () {
    document.body.classList.add("font-loaded");
});

// AOS (Animate On Scroll) refresh on AJAX content load
document.addEventListener("DOMContentLoaded", function () {
    if (typeof AOS === "undefined") return;
    jQuery(document).on("sf:ajaxfinish", function () {
        AOS.refreshHard();
    });

    var target = document.querySelector("#block-search-and-filter");
    if (target) {
        var resizeObserver = new ResizeObserver(function () {
            AOS.refreshHard();
        });
        resizeObserver.observe(target);
    }
});

// Header Buttons in Mega Menu Mobile
document.addEventListener("DOMContentLoaded", function () {
    const headerButtons = document.querySelector(".header-buttons");
    const megaMenu = document.querySelector("#mega-menu-primary");

    const liButtons = document.createElement("li");
    liButtons.className =
        "mega-menu-item mega-menu-item-type-custom mega-align-bottom-left mega-menu-flyout menu-item-header-buttons";

    let isInMegaMenu = false;

    function moveButtonsToMenu() {
        if (window.innerWidth <= 1000 && !isInMegaMenu) {
            if (headerButtons && megaMenu) {
                liButtons.appendChild(headerButtons);
                megaMenu.appendChild(liButtons);
                isInMegaMenu = true;
            }
        } else if (window.innerWidth > 1000 && isInMegaMenu) {
            const originalContainer =
                document.querySelector(".content-elements");
            if (originalContainer && headerButtons) {
                originalContainer.appendChild(headerButtons);
                if (liButtons.parentNode)
                    liButtons.parentNode.removeChild(liButtons);
                isInMegaMenu = false;
            }
        }
    }

    moveButtonsToMenu();
    window.addEventListener("resize", moveButtonsToMenu);
});

// Number Counter Animation (Tick up - Repeats on Scroll)
document.addEventListener("DOMContentLoaded", function () {
    const counters = document.querySelectorAll(".tick-up-number");
    if (!counters.length) return;

    // Store the original target values
    counters.forEach((counter) => {
        if (!counter.hasAttribute("data-target")) {
            counter.setAttribute("data-target", counter.innerText);
        }
    });

    const animateCounters = (entries, observer) => {
        entries.forEach((entry) => {
            const counter = entry.target;
            const targetText = counter.getAttribute("data-target");
            const targetTextClean = targetText.replace(/,/g, "");
            const target = parseFloat(targetTextClean);
            const isFloat = targetTextClean.includes(".");

            if (isNaN(target) || target === 0) return;

            if (entry.isIntersecting) {
                // Prevent overlapping animations if already running
                if (counter.dataset.animating === "true") return;
                counter.dataset.animating = "true";

                counter.innerText = "0";

                let startTimestamp = null;
                const duration = 2000; // 2 seconds animation

                const step = (timestamp) => {
                    // Cancel animation if it scrolled out of view
                    if (counter.dataset.animating === "false") return;

                    if (!startTimestamp) startTimestamp = timestamp;
                    const progress = Math.min(
                        (timestamp - startTimestamp) / duration,
                        1,
                    );

                    // Ease out quad
                    const easeOut = progress * (2 - progress);
                    const currentVal = target * easeOut;

                    if (isFloat) {
                        counter.innerText = currentVal.toFixed(1);
                    } else {
                        counter.innerText = Math.floor(currentVal);
                    }

                    if (progress < 1) {
                        window.requestAnimationFrame(step);
                    } else {
                        counter.innerText = targetText;
                    }
                };

                window.requestAnimationFrame(step);
            } else {
                // Reset when out of view to animate again
                counter.dataset.animating = "false";
                counter.innerText = "0";
            }
        });
    };

    const counterObserver = new IntersectionObserver(animateCounters, {
        threshold: 0.2, // Start earlier
    });

    counters.forEach((counter) => {
        counterObserver.observe(counter);
    });
});

// ── Testimonial Slider ────────────────────────────────────────────────────────
document.addEventListener("DOMContentLoaded", function () {
    const testimonialSwiper = document.querySelector(".testimonial-swiper");
    if (!testimonialSwiper) return;

    new Swiper(testimonialSwiper, {
        loop: false,
        speed: 700,
        slidesPerView: 1,
        allowTouchMove: true,
        grabCursor: true,
        effect: "fade",
        fadeEffect: {
            crossFade: true,
        },
        navigation: {
            nextEl: ".ts-next",
            prevEl: ".ts-prev",
        },
        cssMode: false,
        autoHeight: false,
    });
});

// ── Timeline ──────────────────────────────────────────────────────────────────
document.addEventListener("DOMContentLoaded", function () {
    const timelineSwiper = document.querySelector(".timeline-swiper");
    if (!timelineSwiper) return;

    const slides = timelineSwiper.querySelectorAll(".swiper-slide");
    const years = Array.from(slides).map((slide) =>
        slide.getAttribute("data-year"),
    );
    const wrapper = timelineSwiper.closest(".timeline-slider-wrapper");
    const initialSlide = wrapper
        ? parseInt(wrapper.getAttribute("data-initial-slide"), 10) || 0
        : 0;

    const swiper = new Swiper(timelineSwiper, {
        loop: false,
        speed: 700,
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 0,
        initialSlide: initialSlide,
        watchOverflow: true,
        breakpoints: {
            0: {
                slidesPerView: 1,
                centeredSlides: false,
            },
            992: {
                slidesPerView: "auto",
                centeredSlides: true,
            },
        },
        navigation: {
            nextEl: ".timeline-next",
            prevEl: ".timeline-prev",
            disabledClass: "swiper-button-disabled",
        },
        pagination: {
            el: ".timeline-pagination",
            clickable: true,
            renderBullet: function (index, className) {
                return (
                    '<span class="' +
                    className +
                    '">' +
                    (years[index] ? years[index] : "") +
                    "</span>"
                );
            },
        },
        on: {
            init(s) {
                s.navigation?.update();
            },
            slideChange(s) {
                s.navigation?.update();
            },
        },
    });

    swiper.navigation?.update();
});

// Featured Webinar Block - Webinar slider
document.addEventListener("DOMContentLoaded", function () {
    const webinarsSlider = document.querySelector(
        ".block-featured-webinar__webinar",
    );
    if (!webinarsSlider) return;

    new Swiper(webinarsSlider, {
        autoplay: true ,
        loop: false,
        speed: 700,
        slidesPerView: 1,
        allowTouchMove: true,
        grabCursor: true,
        effect: "fade",
        fadeEffect: {
            crossFade: true,
        },
        cssMode: false,
        autoHeight: false,
        pagination: {
            el: webinarsSlider.querySelector(".swiper-pagination"),
            clickable: true,
        },
    });
});

// Single Team Member - Videos slider
document.addEventListener("DOMContentLoaded", function () {
    const relatedArticlesSlider = document.querySelector(
        ".tm-videos-section__videos",
    );
    if (!relatedArticlesSlider) return;

    new Swiper(relatedArticlesSlider, {
        loop: true,
        speed: 700,
        slidesPerView: 2,
        allowTouchMove: true,
        grabCursor: true,
        cssMode: false,
        autoHeight: false,
        spaceBetween: 29,
        navigation: {
            nextEl: relatedArticlesSlider.querySelector(".swiper-button-next"),
            prevEl: relatedArticlesSlider.querySelector(".swiper-button-prev"),
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
            },
        },
    });
});

// Single Team Member - Related articles slider
document.addEventListener("DOMContentLoaded", function () {
    const relatedArticlesSlider = document.querySelector(
        ".tm-related-articles__articles",
    );
    if (!relatedArticlesSlider) return;

    new Swiper(relatedArticlesSlider, {
        loop: true,
        speed: 700,
        slidesPerView: 4,
        allowTouchMove: true,
        grabCursor: true,
        cssMode: false,
        autoHeight: false,
        spaceBetween: 29,
        navigation: {
            nextEl: relatedArticlesSlider.querySelector(".swiper-button-next"),
            prevEl: relatedArticlesSlider.querySelector(".swiper-button-prev"),
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            577: {
                slidesPerView: 2,
            },
            992: {
                slidesPerView: 3,
            },
            1301: {
                slidesPerView: 4,
            },
        },
    });
});

// Anchorlinks sticky offset: header height + WP admin bar.
document.addEventListener("DOMContentLoaded", function () {
    const root = document.documentElement;
    const header = document.querySelector("header.header-site");
    if (!header) return;

    const getAdminBarHeight = () => {
        const adminBar = document.getElementById("wpadminbar");
        return adminBar ? adminBar.offsetHeight : 0;
    };

    const setAnchorlinksOffset = () => {
        const headerHeight = header.offsetHeight || 0;
        const adminBarHeight = getAdminBarHeight();
        root.style.setProperty(
            "--anchorlinks-sticky-top",
            `${headerHeight + adminBarHeight}px`,
        );
    };

    let ticking = false;
    const requestOffsetUpdate = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
            setAnchorlinksOffset();
            ticking = false;
        });
    };

    setAnchorlinksOffset();
    window.addEventListener("resize", requestOffsetUpdate);
    window.addEventListener("scroll", requestOffsetUpdate, { passive: true });
});

// Anchorlinks: always align target below sticky UI.
document.addEventListener("DOMContentLoaded", function () {
    const getAdminBarHeight = () => {
        const adminBar = document.getElementById("wpadminbar");
        return adminBar ? adminBar.offsetHeight : 0;
    };

    const getHeaderHeight = () => {
        const header = document.querySelector("header.header-site");
        return header ? header.offsetHeight : 0;
    };

    const getAnchorBarHeight = () => {
        const anchorBar = document.querySelector(".anchorlinks__bar");
        return anchorBar ? anchorBar.offsetHeight : 0;
    };

    const getScrollOffset = () =>
        getHeaderHeight() + getAdminBarHeight() + getAnchorBarHeight();

    const getAlignedTarget = (hash) => {
        if (!hash || hash === "#") return;
        const target = document.querySelector(hash);
        if (!target) return null;

        // If the anchor is inside a block section, align to the section edge
        // instead of inner container content (prevents "entered" offset).
        return target.closest(".general-section") || target;
    };

    const getHashFromHref = (href) => {
        if (!href) return "";
        const resolveHash = (hash) => {
            if (!hash || hash === "#") return "";
            try {
                return document.querySelector(hash) ? hash : "";
            } catch (error) {
                return "";
            }
        };
        if (href.startsWith("#")) {
            return resolveHash(href);
        }
        try {
            const parsed = new URL(href, window.location.href);
            return resolveHash(parsed.hash || "");
        } catch (error) {
            return "";
        }
    };

    const anchorLinks = Array.from(
        document.querySelectorAll(".anchorlinks__link"),
    ).filter((link) => getHashFromHref(link.getAttribute("href")));
    const stickyTransitionMs = 220;
    const isStickyViewport = () => window.matchMedia("(min-width: 768px)").matches;
    const stickyTimers = new WeakMap();
    const stickyLastApplied = new WeakMap();

    const clearStickyInactiveClasses = (blockRoot, bar) => {
        if (blockRoot) {
            blockRoot.classList.remove("is-sticky-inactive");
        }
        if (bar) {
            bar.classList.remove("is-sticky-inactive");
        }
    };

    const forceMobileNoSticky = () => {
        document.querySelectorAll(".anchorlinks").forEach((blockRoot) => {
            const bar = blockRoot.querySelector(".anchorlinks__bar");
            const prevTimer = stickyTimers.get(blockRoot);
            if (prevTimer) {
                window.clearTimeout(prevTimer);
                stickyTimers.delete(blockRoot);
            }
            blockRoot.style.position = "";
            blockRoot.style.top = "";
            if (bar) {
                bar.style.position = "";
                bar.style.top = "";
            }
            clearStickyInactiveClasses(blockRoot, bar);
            stickyLastApplied.delete(blockRoot);
        });
    };

    const setNodeStickyPosition = (node, enabled) => {
        if (!node) return;
        node.style.position = enabled ? "sticky" : "static";
        node.style.top = enabled ? "var(--anchorlinks-sticky-top, 120px)" : "";
    };

    const setStickyEnabledForBlock = (blockRoot, enabled) => {
        if (!blockRoot || !isStickyViewport()) return;
        const bar = blockRoot.querySelector(".anchorlinks__bar");

        const last = stickyLastApplied.get(blockRoot);
        if (last === enabled) return;
        stickyLastApplied.set(blockRoot, enabled);

        const prevTimer = stickyTimers.get(blockRoot);
        if (prevTimer) {
            window.clearTimeout(prevTimer);
            stickyTimers.delete(blockRoot);
        }

        if (enabled) {
            setNodeStickyPosition(blockRoot, true);
            setNodeStickyPosition(bar, true);
            window.requestAnimationFrame(() => {
                clearStickyInactiveClasses(blockRoot, bar);
            });
            return;
        }

        blockRoot.classList.add("is-sticky-inactive");
        if (bar) {
            bar.classList.add("is-sticky-inactive");
        }
        const timerId = window.setTimeout(() => {
            setNodeStickyPosition(blockRoot, false);
            setNodeStickyPosition(bar, false);
            stickyTimers.delete(blockRoot);
        }, stickyTransitionMs);
        stickyTimers.set(blockRoot, timerId);
    };

    const getScrollOffsetForBlock = (blockRoot) => {
        const bar = blockRoot?.querySelector(".anchorlinks__bar");
        const barH = bar ? bar.offsetHeight : 0;
        return getHeaderHeight() + getAdminBarHeight() + barH + 4;
    };

    /** Bottom edge (viewport Y) of the linked “section end” for sticky release. */
    const getLinkedSectionBottomY = (visibleHash) => {
        const el = document.querySelector(visibleHash);
        if (!el) return null;
        const gs = el.closest(".general-section");
        let measureEl = gs || el;
        if (gs) {
            const gsH = gs.getBoundingClientRect().height;
            const elH = el.getBoundingClientRect().height;
            if (gsH > window.innerHeight * 1.35 && elH >= 24) {
                measureEl = el;
            }
        }
        return measureEl.getBoundingClientRect().bottom;
    };

    const getInternalSectionHash = (visibleHash) => {
        const alignedTarget = getAlignedTarget(visibleHash);
        if (!alignedTarget || !alignedTarget.id) return "";
        return `#${alignedTarget.id}`;
    };

    const setActiveAnchorLink = (sectionHash) => {
        anchorLinks.forEach((link) => {
            const visibleHash = getHashFromHref(link.getAttribute("href"));
            const linkSectionHash = getInternalSectionHash(visibleHash);
            const isActive = !!sectionHash && linkSectionHash === sectionHash;
            link.classList.toggle("is-active", isActive);
            if (isActive) {
                link.setAttribute("aria-current", "true");
            } else {
                link.removeAttribute("aria-current");
            }
        });
    };

    const scrollToHashTarget = (hash, behavior = "smooth") => {
        const alignedTarget = getAlignedTarget(hash);
        if (!alignedTarget) return;

        const targetTop =
            alignedTarget.getBoundingClientRect().top + window.pageYOffset;
        const top = Math.max(0, targetTop - getScrollOffset());

        window.scrollTo({
            top,
            behavior,
        });
    };

    anchorLinks.forEach((link) => {
        link.addEventListener("click", function (event) {
            const hash = getHashFromHref(this.getAttribute("href"));
            if (!hash || hash === "#") return;
            event.preventDefault();
            scrollToHashTarget(hash, "smooth");
            if (window.history && window.history.pushState) {
                window.history.pushState(null, "", hash);
            }
            // Let the real scroll position decide active state after smooth scroll starts.
            requestUpdateActiveOnScroll();
            window.setTimeout(requestUpdateActiveOnScroll, 120);
        });
    });

    const updateActiveAnchorOnScroll = () => {
        if (!anchorLinks.length) return;
        if (!isStickyViewport()) {
            forceMobileNoSticky();
        }
        const offset = getScrollOffset() + 4;
        let activeSectionHash = "";
        let bestTop = -Infinity;
        let isPastLastLinkedSection = false;

        if (isStickyViewport()) {
            document.querySelectorAll(".anchorlinks").forEach((blockRoot) => {
                const blockLinks = Array.from(
                    blockRoot.querySelectorAll(".anchorlinks__link"),
                ).filter((link) =>
                    getHashFromHref(link.getAttribute("href")),
                );
                if (!blockLinks.length) return;
                const lastInBlock = blockLinks[blockLinks.length - 1];
                const lastHash = getHashFromHref(
                    lastInBlock.getAttribute("href"),
                );
                const bottomY = getLinkedSectionBottomY(lastHash);
                const releaseLine = getScrollOffsetForBlock(blockRoot);
                const pastBlock =
                    typeof bottomY === "number" && bottomY < releaseLine;
                setStickyEnabledForBlock(blockRoot, !pastBlock);
            });
        }

        const lastLink = anchorLinks[anchorLinks.length - 1];
        if (lastLink) {
            const lastVisibleHash = getHashFromHref(
                lastLink.getAttribute("href"),
            );
            const bottomY = getLinkedSectionBottomY(lastVisibleHash);
            const blockForLast = lastLink.closest(".anchorlinks");
            const releaseForLast = blockForLast
                ? getScrollOffsetForBlock(blockForLast)
                : getScrollOffset() + 4;
            isPastLastLinkedSection =
                typeof bottomY === "number" && bottomY < releaseForLast;
        }

        anchorLinks.forEach((link) => {
            const visibleHash = getHashFromHref(link.getAttribute("href"));
            const sectionHash = getInternalSectionHash(visibleHash);
            const target = getAlignedTarget(sectionHash);
            if (!target) return;
            const top = target.getBoundingClientRect().top;
            if (top <= offset && top > bestTop) {
                bestTop = top;
                activeSectionHash = sectionHash;
            }
        });

        // Fallback to the first section before passing it.
        if (
            !activeSectionHash &&
            !isPastLastLinkedSection &&
            anchorLinks.length
        ) {
            const firstVisibleHash = getHashFromHref(
                anchorLinks[0].getAttribute("href"),
            );
            activeSectionHash = getInternalSectionHash(firstVisibleHash);
        }

        setActiveAnchorLink(activeSectionHash);
    };

    const alignCurrentHashToSectionEdge = () => {
        if (!window.location.hash) return;
        scrollToHashTarget(window.location.hash, "auto");
    };

    if (window.location.hash) {
        if ("scrollRestoration" in window.history) {
            window.history.scrollRestoration = "manual";
        }
        setActiveAnchorLink(getInternalSectionHash(window.location.hash));

        // 1) right after DOM is ready
        setTimeout(alignCurrentHashToSectionEdge, 0);
        // 2) after full load (images/fonts can shift layout)
        window.addEventListener("load", alignCurrentHashToSectionEdge, {
            once: true,
        });
        // 3) one more pass for late layout shifts (AOS, async rendering)
        setTimeout(alignCurrentHashToSectionEdge, 250);

        // 4) force alignment for the first second after load
        window.addEventListener(
            "load",
            () => {
                const hash = window.location.hash;
                let attempts = 0;
                const maxAttempts = 20;
                const timer = window.setInterval(() => {
                    const alignedTarget = getAlignedTarget(hash);
                    if (!alignedTarget) {
                        window.clearInterval(timer);
                        return;
                    }

                    const expectedTop = getScrollOffset();
                    const currentTop =
                        alignedTarget.getBoundingClientRect().top;
                    const delta = Math.abs(currentTop - expectedTop);

                    if (delta <= 2 || attempts >= maxAttempts) {
                        window.clearInterval(timer);
                        return;
                    }

                    scrollToHashTarget(hash, "auto");
                    attempts += 1;
                }, 50);
            },
            { once: true },
        );
    } else {
        updateActiveAnchorOnScroll();
    }

    let ticking = false;
    const requestUpdateActiveOnScroll = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
            updateActiveAnchorOnScroll();
            ticking = false;
        });
    };

    window.addEventListener("scroll", requestUpdateActiveOnScroll, {
        passive: true,
    });
    window.addEventListener("resize", requestUpdateActiveOnScroll);
    window.addEventListener("load", requestUpdateActiveOnScroll);
});

// Custom File Input for Gravity Forms

document.addEventListener("DOMContentLoaded", function () {
    const fileFields = document.querySelectorAll(
        ".cta-form .gfield--type-fileupload",
    );

    fileFields.forEach((field) => {
        const fileInput = field.querySelector('input[type="file"]');
        const container = field.querySelector(".ginput_container_fileupload");

        if (fileInput && container) {
            const existingLabel = container.querySelector(
                "label.gform_fileupload_file",
            );
            if (existingLabel) existingLabel.style.display = "none";

            const existingText = container.querySelector(
                '[id*="gform_upload_message"]',
            );
            if (existingText) existingText.style.display = "none";

            let fileStatus = container.querySelector(".file-status-text");
            if (!fileStatus) {
                fileStatus = document.createElement("span");
                fileStatus.className = "file-status-text";
                fileStatus.textContent = "No file chosen";
                fileStatus.style.cssText = `
                        color: #003349;
                        font-size: 15px;
                        margin-left: 18px;
                    `;
                container.appendChild(fileStatus);
            }

            fileInput.addEventListener("change", function () {
                const fileStatus = container.querySelector(".file-status-text");
                if (this.files && this.files.length > 0) {
                    const file = this.files[0];
                    fileStatus.textContent = file.name;
                    fileStatus.style.color = "#333";
                } else {
                    fileStatus.textContent = "No file chosen";
                    fileStatus.style.color = "#666";
                }
            });
        }
    });
});

// Add asterisk to required fields in Gravity Forms
jQuery(document).ready(function ($) {
    $(".gform-field-label").each(function () {
        $(this).html(
            $(this).html().replace("*", '<span class="required-mark">*</span>'),
        );
    });
});

document.addEventListener("DOMContentLoaded", function () {
    if (typeof Swiper === "undefined") return;

    document
        .querySelectorAll(".js-hero-latest-resources-swiper")
        .forEach(function (sliderEl, index) {
            if (sliderEl.classList.contains("swiper-initialized")) return;

            const container = sliderEl.closest(
                ".hero-latest-resources__slider-container",
            );
            if (!container) return;

            const prevBtn = container.querySelector(".js-hero-resources-prev");
            const nextBtn = container.querySelector(".js-hero-resources-next");

            const uid = "hlr-" + index;
            if (prevBtn) prevBtn.setAttribute("id", uid + "-prev");
            if (nextBtn) nextBtn.setAttribute("id", uid + "-next");

            new Swiper(sliderEl, {
                slidesPerView: 1,
                spaceBetween: 20,
                loop: true,
                speed: 600,
                navigation: {
                    prevEl: prevBtn ? "#" + uid + "-prev" : null,
                    nextEl: nextBtn ? "#" + uid + "-next" : null,
                },
            });
        });
});
// ── Video Modal ──────────────────────────────────────────────────────────────────
jQuery(document).ready(function ($) {
    $('.video-modal-module--trigger').not('.popup-youtube').magnificPopup({
        type: 'inline',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        closeBtnInside: true,
        callbacks: {
            open: function () {
                var videoElement = $(this.content).find('video')[0];
                if (videoElement) {
                    videoElement.play();
                }
            },
            close: function () {
                var videoElement = $(this.content).find('video')[0];
                if (videoElement) {
                    videoElement.pause();
                }
            }
        }
    });

    $('.popup-youtube').magnificPopup({
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: true,
        iframe: {
            patterns: {
                youtube: {
                    index: 'youtube.com/',
                    id: 'v=',
                    src: '//www.youtube.com/embed/%id%?autoplay=0'
                },
                youtube_short: {
                    index: 'youtu.be/',
                    id: 'youtu.be/',
                    src: '//www.youtube.com/embed/%id%?autoplay=0'
                },
                vimeo: {
                    index: 'vimeo.com/',
                    id: '/',
                    src: '//player.vimeo.com/video/%id%?autoplay=0'
                }
            }
        }
    });
});

// ── Testimonials Videos Slider (Swiper) ──────────────────────────────────────
document.addEventListener('DOMContentLoaded', function () {
    var tvSliders = document.querySelectorAll('.testimonials-videos__slider');
    if (!tvSliders || tvSliders.length === 0) return;

    tvSliders.forEach(function (sliderEl) {
        var nextEl = sliderEl.querySelector('.testimonials-videos__next');
        var prevEl = sliderEl.querySelector('.testimonials-videos__prev');

        var tvSwiper = new Swiper(sliderEl, {
            loop: true,
            speed: 700,
            slidesPerView: 1,
            spaceBetween: 0,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            autoHeight: true,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
        });

        function pauseAllVideosInSlider() {
            var videos = sliderEl.querySelectorAll('.content-video video');
            videos.forEach(function (v) {
                try {
                    v.pause();
                    v.removeAttribute('controls');
                } catch (e) { }
            });

            var plays = sliderEl.querySelectorAll('.content-video .play');
            plays.forEach(function (p) {
                try { p.style.display = 'block'; } catch (e) { }
            });
        }

        tvSwiper.on('slideChangeTransitionStart', function () {
            pauseAllVideosInSlider();
        });
    });
});

// Single Team Member - Video slider - Youtube modal
document.addEventListener('DOMContentLoaded', function () {
    const modal = document.querySelector('.tm-video-modal');
    const modalContent = document.querySelector('.tm-video-modal__content');
    const modalOverlay = document.querySelector('.tm-video-modal__overlay');
    const modalClose = document.querySelector('.tm-video-modal__close');

    const videoSlides = document.querySelectorAll('.tm-videos-section__videos__box');

    if (!modal || !modalContent || !videoSlides.length) return;

    videoSlides.forEach(slide => {
        slide.addEventListener('click', function () {
            const videoId = this.dataset.videoId;
            if (!videoId) return;
            const iframe = `
                <iframe
                    src="https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0"
                    title="YouTube video player"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    allowfullscreen>
                </iframe>
            `;
            modalContent.innerHTML = iframe;
            modal.classList.add('active');
            const scrollbarWidth =
                window.innerWidth - document.documentElement.clientWidth;

            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = `${scrollbarWidth}px`;
        });
    });

    function closeModal() {
        modal.classList.remove('active');
        modalContent.innerHTML = '';
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
    }

    modalOverlay.addEventListener('click', closeModal);
    modalClose.addEventListener('click', closeModal);
});

// Block Meet the Team custom tabs
document.addEventListener('DOMContentLoaded', function () {
    const sections = document.querySelectorAll('.block-departments-team-members__tabs');
    if (sections.length === 0) return;

    sections.forEach(tabWrapper => {
        const buttons = tabWrapper.querySelectorAll('button');
        const section = tabWrapper.closest('section');
        const members = section.querySelectorAll('[data-category]');
        const emptyMessage = section.querySelector('.no-members-message');
        const activeButton = tabWrapper.querySelector('.active');
        const row = section.querySelector('.row');
        const loadMoreBtn = section.querySelector('.load-more-btn');

        let currentLimit = 4;
        let currentFilter = 'all';

        function applyFilter(filter) {
            currentFilter = filter;
            let visibleCount = 0;
            let matchingCount = 0;

            members.forEach(member => {
                const categories = member.dataset.category.split(' ');
                if (
                    filter === 'all' ||
                    categories.includes(filter)
                ) {
                    matchingCount++;
                    if (visibleCount < currentLimit) {
                        member.style.display = '';
                        visibleCount++;
                    } else {
                        member.style.display = 'none';
                    }
                } else {
                    member.style.display = 'none';
                }
            });

            emptyMessage.style.display = visibleCount === 0
                ? 'block'
                : 'none';

            if (loadMoreBtn) {
                if (matchingCount > visibleCount) {
                    loadMoreBtn.style.display = 'inline-flex';
                } else {
                    loadMoreBtn.style.display = 'none';
                }
            }
            row.classList.remove('is-transitioning');
            AOS.refresh();
        }

        buttons.forEach(button => {
            button.addEventListener('click', function () {
                buttons.forEach(btn => btn.classList.remove('active'));
                this.classList.add('active');
                row.classList.add('is-transitioning');
                currentLimit = 4; // reset limit on tab change
                setTimeout(() => {
                    applyFilter(this.dataset.filter);
                }, 200);
            });
        });

        if (loadMoreBtn) {
            loadMoreBtn.addEventListener('click', function () {
                currentLimit += 4;
                applyFilter(currentFilter);
            });
        }

        if (activeButton) {
            applyFilter(activeButton.dataset.filter);
            setTimeout(() => {
                AOS.refresh();
            }, 200);
        }
    });
});
document.addEventListener('change', function (e) {
    const input = e.target;

    if (!input.matches('.gform_wrapper input[type="file"]')) {
        return;
    }

    const form = input.closest('form');
    if (!form) return;

    const submitButton = form.querySelector('input[type="submit"], button.gform_button');
    const allFileInputs = form.querySelectorAll('input[type="file"]');
    const maxSize = 100 * 1024 * 1024; // 100MB

    let hasInvalidFile = false;

    allFileInputs.forEach(fileInput => {
        if (fileInput.files && fileInput.files[0] && fileInput.files[0].size > maxSize) {
            hasInvalidFile = true;
        }
    });

    // Find or create an element to display the error message next to the submit button
    let errorMsg = form.querySelector('.gform-custom-file-error');

    if (hasInvalidFile) {
        if (!errorMsg) {
            errorMsg = document.createElement('span');
            errorMsg.className = 'gform-custom-file-error';
            errorMsg.style.cssText = 'color: #dc3545; font-size: 15px; margin-left: 15px; display: inline-block; vertical-align: middle; font-weight: 600;';

            if (submitButton) {
                submitButton.parentNode.insertBefore(errorMsg, submitButton.nextSibling);
            } else {
                const footer = form.querySelector('.gform_footer');
                if (footer) {
                    footer.appendChild(errorMsg);
                }
            }
        }

        errorMsg.textContent = 'Maximum file size is 100MB';
        errorMsg.style.display = 'inline-block';

        if (submitButton) {
            submitButton.disabled = true;
            submitButton.style.opacity = '0.5';
            submitButton.style.cursor = 'not-allowed';
        }
    } else {
        // If there are no invalid files, hide the error and re-enable the button
        if (errorMsg) {
            errorMsg.style.display = 'none';
            errorMsg.textContent = '';
        }
        if (submitButton) {
            submitButton.disabled = false;
            submitButton.style.opacity = '';
            submitButton.style.cursor = '';
        }
    }
});